const HNSColors = {
  primary: {
    200: "#041F58",
    300: "#072F83",
    400: "#093EAF",
    500: "#0B4EDB",
    600: "#3771EC",
    700: "#6D95E9",
    800: "#9DB8F1",
    900: "#CED7F8",
  },
  secondary: {
    100: "#1C0C52",
    200: "#211150",
    300: "#311977",
    400: "#42229F",
    450: "#4232CC",
    500: "#522AC7",
    600: "#7555D2",
    700: "#977FDD",
    800: "#BAAAE9",
    900: "#DCD4F4",
    950: "#F0DFFE",
  },
  tertiary: {
    200: "#224E70",
    300: "#3272A3",
    400: "#4192D0",
    500: "#55AFF4",
    600: "#77BFF6",
    700: "#99CFF8",
    800: "#B2DDFF",
    900: "#DDEFFD",
    950: "#F1F6FF",
    975: "#F7FAFF",
  },
  neutrals: {
    100: "#232323",
    200: "#2B2C2E",
    300: "#47494C",
    400: "#6A6D71",
    500: "#8E9197",
    600: "#AAADB1",
    700: "#C6C8CB",
    800: "#EFEFF0",
    900: "#FFFFFF",
  },
  success: {
    400: "#009138",
    500: "#38DD78",
    600: "#93D8AE",
    700: "#D3FFE4",
    800: "#DEFFEB",
  },
  failure: {
    400: "#9F0003",
    500: "#FF3A3D",
    600: "#F89797",
    700: "#FFD8D9",
    800: "#FFE2E3",
  },
  warning: {
    500: "#F5B537",
    600: "#FFF0B5",
    700: "#FDE8B5",
    800: "#FFAB33",
  },
  sliderNotFilled: "#CED7F8",
};

export default HNSColors;
